module.exports = __webpack_public_path__ + "img/honor11.0.1.0_202602051651.jpg";